import {Injectable} from '@angular/core';
import {Chart} from "angular-highcharts";
import {Options} from "highcharts";

@Injectable({
  providedIn: 'root'
})
export class MlroViewService {


  constructor() {
  }

  getTransactionBreak(res: any): Chart {
      return new Chart({
        chart: {
          type: 'pie',
        },
        title: {
          style: {
            color: '#000000',
            fontSize: '14px'
          },
          text: 'Transactions breakdown on an interval basis [%]'
        },
        series: [{
          name: 'Brands',
          colorByPoint: true,
          data: [
            {
              name: 'Flagged transactions',
              color: '#4982f4',
              y: res.data_info.total_flagged
            },
            {
              name: 'Flagged transactions - reported',
              color: '#da4437',
              y: res.data_info.total_flagged_reported
            },
            {
              name: 'Flagged transactions - not reported',
              color: '#f3b601',
              y: res.data_info.total_flagged_not_reported
            }
          ]
        }],
        credits: {
          enabled: false
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.percentage:.1f} %'
            }
          }
        }
      } as Options);
  }


  getTrxMonth(res): Chart  {
    return  new Chart({
        chart: {
          type: 'column',
        },
        xAxis: {
          categories: ['Customer', 'Retail']
        },
        yAxis: {
          title: {
            text: '# of transactions'
          }
        },
        title: {
          style: {
            color: '#000000',
            fontSize: '14px',
          },
          text: 'TRX types per customer types on a monthly basis [number of cases]'
        },
        series: [
          {
            name: 'Reported Transactions',
            color: '#4982f4',
            data: [res.data_info.corporate_customers_reported_transactions, res.data_info.retail_customers_reported_transactions]
          },
          {
            name: 'Flagged Transactions',
            color: '#005f91',
            data: [res.data_info.corporate_customers_flagged_transactions, res.data_info.retail_customers_flagged_transactions]
          }
        ],
        credits: {
          enabled: false
        }
      } as Options);
  }

  getRiskBreakDown(res: any): Chart  {
      return  new Chart({
        chart: {
          type: 'column',
        },
        xAxis: {
          categories: ['Risk 1', 'Risk 2', 'Risk 3', 'Risk 4'],
        },
        yAxis: {
          title: {
            text: '# of customers'
          }
        },
        title: {
          style: {
            color: '#000000',
            fontSize: '14px',
          },
          text: 'Risk categories with customer breakdown on a monthly basis [number of customers]'
        },
        series: [

          {
            name: 'Retail',
            color: '#ffb93a',
            data: [res.data_info.retail_customer_risk1, res.data_info.retail_customer_risk2, res.data_info.retail_customer_risk3, res.data_info.retail_customer_risk4]
          },
          {
            name: 'Other',
            color: '#feeb65',
            data: [res.data_info.corporate_customer_risk1, res.data_info.corporate_customer_risk2, res.data_info.corporate_customer_risk3, res.data_info.corporate_customer_risk4]
          }
        ],
        credits: {
          enabled: false
        }
      } as Options);
  }


  getChartReport(): Chart {
    return  new Chart({
      chart: {
        type: 'column',
      },
      xAxis: {
        categories: ['January', 'February', 'March', 'April']
      },
      yAxis: {
        title: {
          text: '# of transactions'
        }
      },
      title: {
        style: {
          color: '#000000',
          fontSize: '14px',
        },
        text: 'TRX types per customer types on a yearly basis [number of cases]'
      },
      series: [
        {
          name: 'SAR - loan',
          color: '#003f5c',
          data: [13, 33, 77, 92]
        },
        {
          name: 'SAR - credit card',
          color: '#444e86',
          data: [9, 101, 105, 127]
        },
        {
          name: 'SAR - savings account',
          color: '#955196',
          data: [11, 12, 102, 119]
        },
        {
          name: 'Flagged Transactions - loan',
          color: '#dd5182',
          data: [6, 45, 93, 108]
        },
        {
          name: 'Flagged Transactions - credit card',
          color: '#ff6e54',
          data: [49, 85, 120, 125]
        },
        {
          name: 'Flagged Transactions - savings account',
          color: '#ffa600',
          data: [3, 58, 86, 94]
        }
      ],
      credits: {
        enabled: false
      }
    } as Options);
  }

}
